// Generated by scripts/wizbuild.mjs. Edit the matching WIZ view.ts instead.
// @ts-nocheck
import { Component as AngularComponent } from '@angular/core';
import Wiz from '../../wiz';
import { AfterViewInit, OnChanges, OnDestroy, Input, HostBinding, ViewChild, ElementRef, inject, signal } from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';
import { loadMonaco } from '../../libs/monaco';
const wiz = new Wiz({ appId: 'component.code-editor', namespace: 'code-editor' });
@AngularComponent({
  selector: 'wiz-code-editor',
  templateUrl: './view.html',
  styleUrls: ['./view.scss'],
  standalone: false
})
export class ComponentCodeEditorComponent implements AfterViewInit, OnChanges, OnDestroy, ControlValueAccessor {
 @Input() language='plaintext';
 @Input() rows=8;
 @Input() label='내용 편집';
 @Input() placeholder='';
 @Input() maxlength?:number;
 @Input() readonly=false;
 @Input() tabIndent=false;
 @Input() @HostBinding('class.fill') fill=false;
 @ViewChild('container') container!:ElementRef<HTMLElement>;
 public loading=signal(true);public error=signal('');
 private control=inject(NgControl,{self:true,optional:true});
 private editor:any;private model:any;private monaco:any;private destroyed=false;private value='';private disabled=false;private updating=false;
 private change:(value:string)=>void=()=>{};private touched:()=>void=()=>{};
 constructor(){if(this.control)this.control.valueAccessor=this;}
 public async ngAfterViewInit():Promise<void>{
  try{
   this.monaco=await loadMonaco();if(this.destroyed)return;
   this.model=this.monaco.editor.createModel(this.value,this.language);
   if(this.tabIndent)this.model.updateOptions({tabSize:2,insertSpaces:true});
   this.editor=this.monaco.editor.create(this.container.nativeElement,{model:this.model,theme:'vs',automaticLayout:true,minimap:{enabled:false},fontSize:15,lineNumbers:this.language==='plaintext'?'off':'on',wordWrap:'on',scrollBeyondLastLine:false,readOnly:this.readonly||this.disabled,ariaLabel:this.label,tabSize:2,tabFocusMode:!this.tabIndent,stickyScroll:{enabled:false},padding:{top:12,bottom:12}});
   this.editor.onDidChangeModelContent(()=>{if(this.updating)return;let next=this.model.getValue();if(this.maxlength&&next.length>this.maxlength){next=next.slice(0,this.maxlength);this.writeValue(next);}this.value=next;this.change(next);});
   this.editor.onDidBlurEditorWidget(()=>this.touched());
  }catch(error){this.error.set(error instanceof Error?error.message:'편집기를 불러오지 못했습니다.');}finally{this.loading.set(false);}
 }
 public ngOnChanges():void{if(this.editor){this.monaco.editor.setModelLanguage(this.model,this.language);this.editor.updateOptions({readOnly:this.readonly||this.disabled,ariaLabel:this.label,tabFocusMode:!this.tabIndent});if(this.tabIndent)this.model.updateOptions({tabSize:2,insertSpaces:true});}}
 /** A wrapping form label otherwise moves focus to Monaco's readonly IME textarea. */
 public preserveEditorFocus(event:MouseEvent):void{if(this.container.nativeElement.closest('label'))event.preventDefault();}
 public writeValue(value:any):void{this.value=String(value??'');if(this.model&&this.model.getValue()!==this.value){this.updating=true;this.model.setValue(this.value);this.updating=false;}}
 public registerOnChange(fn:(value:string)=>void):void{this.change=fn;}
 public registerOnTouched(fn:()=>void):void{this.touched=fn;}
 public setDisabledState(disabled:boolean):void{this.disabled=disabled;this.editor?.updateOptions({readOnly:this.readonly||disabled});}
 public ngOnDestroy():void{this.destroyed=true;this.editor?.dispose();this.model?.dispose();}
}

export default ComponentCodeEditorComponent;
